import { defineMessage } from 'react-intl'

export const middleDotSeparatorMessage = defineMessage({
  id: 'eD+bIGki/X',
  defaultMessage: '·',
  description: 'Middle dot separator character used between items',
})

export const pipeSeparatorMessage = defineMessage({
  id: '1LMy5j0nsD',
  defaultMessage: '|',
  description: 'Pipe separator character used between items',
})

export const bulletSeparatorMessage = defineMessage({
  id: 'UO0e3sXu/k',
  defaultMessage: '•',
  description: 'Bullet separator character used between items',
})
